import { css } from "@emotion/react";

import { popOverShadow } from "~/client/styles/emotion/mixins/boxShadow";
import { smallerPc } from "~/client/styles/emotion/mixins/responsive";
import tokens from "~/packages/design-tokens/dist/tokens";

export const panelCss = css({
  ...popOverShadow(),
  position: "absolute",
  zIndex: 10,
  marginTop: "5px",
  width: "550px",
  border: `1px solid ${tokens.color.border.primary.value}`,
  borderRadius: tokens.borderRadius.primary.value,
  background: tokens.color.white.value,
  ...smallerPc({
    width: "550px",
  }),
});
